var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKmb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "628px",
    height: "568px",
    viewBox: "0 0 628 568",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "line illustration 01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-7",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-9",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-11",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-13",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-15",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-17",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-19",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-21",
    x: 404,
    y: 372,
    width: 196,
    height: 196
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 196,
    height: 196,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-23",
    x: 496,
    y: 0,
    width: 132,
    height: 568
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 132,
    height: 568,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-23"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Panels/About-KMB",
    transform: "translate(-736.000000, -142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line-illustration-01",
    transform: "translate(736.000000, 142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(100.000000, 468.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#FFFFFF",
    strokeWidth: 4,
    x: 2,
    y: 2,
    width: 96,
    height: 96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,-59.4277199 L-75.4277199,100 M102,-59.4277199 L-57.4277199,100 M120,-59.4277199 L-39.4277199,100 M138,-59.4277199 L-21.4277199,100 M156,-59.4277199 L-3.42771985,100 M174,-59.4277199 L14.5722801,100 M192,-59.4277199 L32.5722801,100 M210,-59.4277199 L50.5722801,100 M228,-59.4277199 L68.5722801,100 M246,-59.4277199 L86.5722801,100",
    id: "Combined-Shape",
    stroke: "#5E0A17",
    strokeWidth: 4,
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(368.000000, 468.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#FFFFFF",
    strokeWidth: 4,
    x: 2,
    y: 2,
    width: 36,
    height: 36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9838277,-24 L-30,40 M41.2078469,-24 L-22.7759809,40 M48.431866,-24 L-15.5519617,40 M55.6558852,-24 L-8.32794258,40 M62.8799043,-24 L-1.10392344,40 M70.1039234,-24 L6.12009569,40 M77.3279426,-24 L13.3441148,40 M84.5519617,-24 L20.568134,40 M91.7759809,-24 L27.7921531,40 M99,-24 L35.0161723,40",
    id: "Combined-Shape",
    stroke: "#5E0A17",
    strokeWidth: 4,
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, 232.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#FFFFFF",
    strokeWidth: 4,
    x: 2,
    y: 2,
    width: 68,
    height: 68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0716902,-43 L-54,72 M74.0637246,-43 L-41.0079656,72 M87.0557591,-43 L-28.0159312,72 M100.047793,-43 L-15.0238967,72 M113.039828,-43 L-2.03186232,72 M126.031862,-43 L10.9601721,72 M139.023897,-43 L23.9522065,72 M152.015931,-43 L36.9442409,72 M165.007966,-43 L49.9362754,72 M178,-43 L62.9283098,72",
    id: "Combined-Shape",
    stroke: "#5E0A17",
    strokeWidth: 4,
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#FFFFFF",
    strokeWidth: 4,
    x: 2,
    y: 2,
    width: 68,
    height: 68
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, 300.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#FFFFFF",
    strokeWidth: 4,
    x: 2,
    y: 2,
    width: 68,
    height: 68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0716902,-43 L-54,72 M74.0637246,-43 L-41.0079656,72 M87.0557591,-43 L-28.0159312,72 M100.047793,-43 L-15.0238967,72 M113.039828,-43 L-2.03186232,72 M126.031862,-43 L10.9601721,72 M139.023897,-43 L23.9522065,72 M152.015931,-43 L36.9442409,72 M165.007966,-43 L49.9362754,72 M178,-43 L62.9283098,72",
    id: "Combined-Shape",
    stroke: "#5E0A17",
    strokeWidth: 4,
    mask: "url(#mask-10)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#FFFFFF",
    strokeWidth: 4,
    x: 2,
    y: 2,
    width: 68,
    height: 68
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(68.000000, 300.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#FFFFFF",
    strokeWidth: 4,
    x: 2,
    y: 2,
    width: 68,
    height: 68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0716902,-43 L-54,72 M74.0637246,-43 L-41.0079656,72 M87.0557591,-43 L-28.0159312,72 M100.047793,-43 L-15.0238967,72 M113.039828,-43 L-2.03186232,72 M126.031862,-43 L10.9601721,72 M139.023897,-43 L23.9522065,72 M152.015931,-43 L36.9442409,72 M165.007966,-43 L49.9362754,72 M178,-43 L62.9283098,72",
    id: "Combined-Shape",
    stroke: "#5E0A17",
    strokeWidth: 4,
    mask: "url(#mask-14)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#FFFFFF",
    strokeWidth: 4,
    x: 2,
    y: 2,
    width: 68,
    height: 68
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(496.000000, 372.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#FFFFFF",
    strokeWidth: 4,
    x: 2,
    y: 2,
    width: 68,
    height: 68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0716902,-43 L-54,72 M74.0637246,-43 L-41.0079656,72 M87.0557591,-43 L-28.0159312,72 M100.047793,-43 L-15.0238967,72 M113.039828,-43 L-2.03186232,72 M126.031862,-43 L10.9601721,72 M139.023897,-43 L23.9522065,72 M152.015931,-43 L36.9442409,72 M165.007966,-43 L49.9362754,72 M178,-43 L62.9283098,72",
    id: "Combined-Shape",
    stroke: "#5E0A17",
    strokeWidth: 4,
    mask: "url(#mask-18)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#FFFFFF",
    strokeWidth: 4,
    x: 2,
    y: 2,
    width: 68,
    height: 68
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    x: 2,
    y: 370,
    width: 196,
    height: 196
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    x: 370,
    y: 234,
    width: 196,
    height: 272
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 4,
    x: 102,
    y: 470,
    width: 304,
    height: 96
  }), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    mask: "url(#mask-22)",
    strokeWidth: 8,
    strokeDasharray: "4,10",
    transform: "translate(502.000000, 470.000000) scale(-1, -1) translate(-502.000000, -470.000000) ",
    xlinkHref: "#path-21"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle-Copy-6",
    stroke: "#FFFFFF",
    mask: "url(#mask-24)",
    strokeWidth: 8,
    strokeDasharray: "4,10",
    transform: "translate(562.000000, 284.000000) scale(-1, 1) translate(-562.000000, -284.000000) ",
    xlinkHref: "#path-23"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKmb);
export default __webpack_public_path__ + "static/media/KMB.edc3074717e175058f373cfa5ed671b8.svg";
export { ForwardRef as ReactComponent };